import * as React from "react";
import type { SVGProps } from "react";
const SvgAlarmClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m4.59 6.81 2.75-2c.45-.32.55-.95.22-1.4a.996.996 0 0 0-1.4-.22l-2.75 2c-.45.32-.55.95-.22 1.4a1.01 1.01 0 0 0 1.4.22M3.75 13c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8m2 0c0 3.31 2.69 6 6 6s6-2.69 6-6-2.69-6-6-6-6 2.69-6 6m7-1h1c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1zm4.59-8.81 2.75 2A1 1 0 0 1 19.5 7c-.21 0-.41-.06-.59-.19l-2.75-2a.996.996 0 0 1-.22-1.4c.33-.45.95-.54 1.4-.22"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAlarmClock;
